// Invite text builder — one source of truth for what "Share" and "Copy" send.
// The full invite is: message + album link (+ passcode when the album is locked).
import { getHostPasscodePlain } from "./api";

export function defaultShareMessage(album) {
  return `${album.host_name || "Your host"} invited you to add & view photos and videos from "${album.name}" — no sign-up needed!`;
}

export function albumUrl(slug) {
  return `${window.location.origin}/${slug}`;
}

// message: optional override; falls back to the saved custom message, then the default.
export function buildInviteText(album, message) {
  const msg = (message ?? album.share_message ?? "").trim() || defaultShareMessage(album);
  let text = `${msg}\n\n${albumUrl(album.slug)}`;
  if (album.requires_passcode) {
    // Owner responses include host_passcode; fall back to this device's cache.
    const code = album.host_passcode || getHostPasscodePlain(album.slug);
    text += code
      ? `\n🔒 Passcode: ${code}`
      : `\n🔒 This album is passcode-protected — share the code with your guests separately.`;
  }
  return text;
}
